import { createMixpanelAnalytics } from "./mixpanel-analytics";

export function createAnalytics() {
  return createMixpanelAnalytics();
}
